import { useDispatch } from "react-redux";
import { openPopup } from "../../../store/popupSlice"

export default function GrabMulti({data}) {
    const dispatch = useDispatch();
  return (
    <>
      <section className="grab-multi-area">
        <img loading="lazy" src="/assets/home/grab-multi-vec-1.webp" alt="vector" className="img-responsive multi-vec-1" />
        <img loading="lazy" src="/assets/home/grab-multi-vec-2.webp" alt="vector" className="img-responsive multi-vec-2" />
        <img loading="lazy" src="/assets/home/lyft-intro-vec1.webp" alt="vector" className="img-responsive multi-vec-3" />
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-5 col-md-6">
              <div className="grab-multi-img">
                <img loading="lazy" src={data.image} alt="multi service" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="grab-multi-content">
                <label className="mission-label">{data.label}</label>
                <h2 className="heading"><span className="gradiant-color">{data.titlePart1}</span> {data.titlePart2}</h2>
                <small>{data.subHead}</small>
                <p>{data.description}</p>
                <button onClick={() => dispatch(openPopup())} className="default-btn">{data.btn}</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
